import { app } from '../../../app';

app.factory('SaaspassConnectService', SaaspassConnectService);

/** @ngInject */
function SaaspassConnectService($resource) {
    var rootUrl = 'app/rest/admin/company/:id/saaspassconnects';
    return {
        saaspassConnects :  $resource(rootUrl),
    }
}





// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-connect/saaspass-connect.service.js